<form
  name="form"
  *ngIf="form"
  [formGroup]="form"
  autocomplete="off"
  fxLayout="column"
  fxLayoutAlign="space-between center"
>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="catalogs">
    <mat-label>Arquitectura</mat-label>
    <mat-select formControlName="architecture">
      <mat-option
        *ngFor="let architecture of catalogs.getArchitecture"
        [value]="architecture?.id"
      >
        {{ architecture?.name }}
      </mat-option>
    </mat-select>
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.architecture"
      [ngClass]="{ 'error-icon': controlHasError('architecture') }"
      >class</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Prototipo</mat-label>
    <mat-select formControlName="prototype">
      <mat-option
        *ngFor="let prototype of catalogs?.getPrototype"
        [value]="prototype?.id"
      >
        {{ prototype?.name }}
      </mat-option>
    </mat-select>
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.prototype"
      [ngClass]="{ 'error-icon': controlHasError('prototype') }"
    >
      class
    </mat-icon>
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Sector</mat-label>
    <mat-select formControlName="sector">
      <mat-option
        *ngFor="let sector of catalogs?.getSector"
        [value]="sector?.id"
      >
        {{ sector?.name }}
      </mat-option>
    </mat-select>
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.sector"
      [ngClass]="{ 'error-icon': controlHasError('sector') }"
    >
      class
    </mat-icon>
  </mat-form-field>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Bancarización</mat-label>
    <input matInput moneyFormat formControlName="bancking" />
    <mat-icon
      matSuffix
      class="secondary-text"
      [matTooltip]="notification.bancking"
      [ngClass]="{ 'error-icon': controlHasError('bancking') }"
    >
      class
    </mat-icon>
  </mat-form-field>
</form>
